import { Check, Rows3 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getDensity, setDensity, type Density } from "@/lib/density";
import { cn } from "@/lib/utils";

const LEVELS: { value: Density; label: string }[] = [
    { value: "comfortable", label: "Comfortable" },
    { value: "cozy", label: "Cozy" },
    { value: "compact", label: "Compact" },
];

export function DensityToggle() {

    const [density, setLocalDensity] = useState<Density>(() => getDensity());

    const choose = (next: Density) => {

        setDensity(next);
        setLocalDensity(next);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" aria-label="Interface density">
                    <Rows3 />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuLabel>Interface density</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {LEVELS.map((level) => (
                    <DropdownMenuItem key={level.value} onClick={() => choose(level.value)}>
                        <Check className={cn("mr-2 size-4", density === level.value ? "opacity-100" : "opacity-0")} />
                        {level.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
